export const mediaQueries = {
  // this has to be in sync with the tailwind.config.js
  screens: {
    xs: '(min-width: 640px)',
    sm: '(min-width: 768px)',
    md: '(min-width: 1280px)',
    lg: '(min-width: 1768px)'
  }
};
